/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_OverwriteInputs */

const cs_templates_ai_overwrite = /** @type {(inputs: Templates_Ai_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahradit aktuální layout`)
};

const en_templates_ai_overwrite = /** @type {(inputs: Templates_Ai_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace current layout`)
};

/**
* | output |
* | --- |
* | "Replace current layout" |
*
* @param {Templates_Ai_OverwriteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_overwrite = /** @type {((inputs?: Templates_Ai_OverwriteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_OverwriteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_overwrite(inputs)
	return cs_templates_ai_overwrite(inputs)
});